import { makeStyles } from "@material-ui/core";

const accordionStyles = makeStyles((theme) => ({
  expanded: {},
  content: {
    margin: `8px 0px`,
    "&$expanded": {
      margin: `10px 0px`,
    },
  },
  rootSmall: {
    margin: `0px 0px !important`,
    border: `1px solid #e0e0e0 !important`,
    borderRadius: "0px !important",
  },
  disabled: {
    backgroundColor: "gray",
  },
  accordHead: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  accordActionHeader: {
    justifyContent: "space-between",
    width: "100%",
  },
  tableContent: {
    margin: `0px`,
    padding: `10px 24px`,
    "&$expanded": {
      margin: `0px 0px`,
    },
  },
  tableExpanded: {
    margin: `0px 0px !important`,
    "&$expanded": {
      margin: `0px 0px`,
    },
  },
  statsAccord: {
    padding: "0px !important",
    margin: "0px !important",
    "&$expanded": {
      margin: `0px 0px`,
    },
  },
  accordLabel: {
    margin: 0,
    padding: "5px 0px 0px 0px",
  },
  cleanAccordion: {
    boxShadow: "none !important",
    borderRadius: "0px !important",
    borderLeft: "none !important",
    borderRight: "none !important",
    "&.Mui-expanded": {
      margin: "0px",
    },
  },
  cleanContent: {
    margin: "0 !important",
  },
}));

export default accordionStyles;
